/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const OutlinedButtonStyle = styled.button`
  border: none;
  cursor: pointer;
  border-radius: 5px;
  height: 50px;
  font-size: 0.9375rem;
  font-weight: bold;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    flex: 1;
    justify-self: center;

    i {
      font-size: 20px;
    }
  }

  i {
    font-size: 20px;
  }

  transition: 0.5s background-color;
  border: 2px solid
    ${(props) => (props.color ? props.color : props.theme.colors.purple)};
  color: ${(props) => (props.color ? props.color : props.theme.colors.purple)};

  background-color: #fff;

  &:hover {
    opacity: 1;
    background-color: ${(props) =>
      props.color ? props.color : props.theme.colors.purple};
    color: #fff;
  }

  &:focus {
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
    border-color: ${(props) => props.color};
  }

  &:disabled {
    cursor: no-drop;
    background-color: rgb(128, 132, 149);
    border-color: rgb(128, 132, 149);
    color: #fff;
  }
`;

export const TrailingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  right: 0;
`;

export const LeadingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  left: 0;
`;
